import { jsxs as Ce, jsx as W } from "react/jsx-runtime";
import * as Pe from "react";
import D, { useCallback as re, createContext as X, useMemo as T, createElement as h, useContext as ce, useRef as _, useEffect as z, useState as N, useLayoutEffect as _e, forwardRef as E, Children as B, isValidElement as H, cloneElement as ie, Fragment as Ee } from "react";
import { _ as P } from "./extends-hS2Bh-Yp.js";
import "react-dom";
import { $ as De } from "./utils-CTvPli9r.js";
function ae(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function K(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(c) {
    if (e == null || e(c), n === !1 || !c.defaultPrevented) return t == null ? void 0 : t(c);
  };
}
function Me(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function se(...e) {
  return (t) => e.forEach(
    (n) => Me(n, t)
  );
}
function M(...e) {
  return re(se(...e), e);
}
function le(e, t = []) {
  let n = [];
  function o(r, a) {
    const i = /* @__PURE__ */ X(a), l = n.length;
    n = [
      ...n,
      a
    ];
    function d(s) {
      const { scope: u, children: m, ...f } = s, p = (u == null ? void 0 : u[e][l]) || i, $ = T(
        () => f,
        Object.values(f)
      );
      return /* @__PURE__ */ h(p.Provider, {
        value: $
      }, m);
    }
    function v(s, u) {
      const m = (u == null ? void 0 : u[e][l]) || i, f = ce(m);
      if (f) return f;
      if (a !== void 0) return a;
      throw new Error(`\`${s}\` must be used within \`${r}\``);
    }
    return d.displayName = r + "Provider", [
      d,
      v
    ];
  }
  const c = () => {
    const r = n.map((a) => /* @__PURE__ */ X(a));
    return function(i) {
      const l = (i == null ? void 0 : i[e]) || r;
      return T(
        () => ({
          [`__scope${e}`]: {
            ...i,
            [e]: l
          }
        }),
        [
          i,
          l
        ]
      );
    };
  };
  return c.scopeName = e, [
    o,
    Re(c, ...t)
  ];
}
function Re(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const o = e.map(
      (c) => ({
        useScope: c(),
        scopeName: c.scopeName
      })
    );
    return function(r) {
      const a = o.reduce((i, { useScope: l, scopeName: d }) => {
        const s = l(r)[`__scope${d}`];
        return {
          ...i,
          ...s
        };
      }, {});
      return T(
        () => ({
          [`__scope${t.scopeName}`]: a
        }),
        [
          a
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
function de(e) {
  const t = _(e);
  return z(() => {
    t.current = e;
  }), T(
    () => (...n) => {
      var o;
      return (o = t.current) === null || o === void 0 ? void 0 : o.call(t, ...n);
    },
    []
  );
}
function Ae({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [o, c] = Ie({
    defaultProp: t,
    onChange: n
  }), r = e !== void 0, a = r ? e : o, i = de(n), l = re((d) => {
    if (r) {
      const s = typeof d == "function" ? d(e) : d;
      s !== e && i(s);
    } else c(d);
  }, [
    r,
    e,
    c,
    i
  ]);
  return [
    a,
    l
  ];
}
function Ie({ defaultProp: e, onChange: t }) {
  const n = N(e), [o] = n, c = _(o), r = de(t);
  return z(() => {
    c.current !== o && (r(o), c.current = o);
  }, [
    o,
    c,
    r
  ]), n;
}
const Ke = /* @__PURE__ */ X(void 0);
function Te(e) {
  const t = ce(Ke);
  return e || t || "ltr";
}
function Ne(e) {
  const t = _({
    value: e,
    previous: e
  });
  return T(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [
    e
  ]);
}
const Ve = globalThis != null && globalThis.document ? _e : () => {
};
function ke(e) {
  const [t, n] = N(void 0);
  return Ve(() => {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const o = new ResizeObserver((c) => {
        if (!Array.isArray(c) || !c.length) return;
        const r = c[0];
        let a, i;
        if ("borderBoxSize" in r) {
          const l = r.borderBoxSize, d = Array.isArray(l) ? l[0] : l;
          a = d.inlineSize, i = d.blockSize;
        } else
          a = e.offsetWidth, i = e.offsetHeight;
        n({
          width: a,
          height: i
        });
      });
      return o.observe(e, {
        box: "border-box"
      }), () => o.unobserve(e);
    } else
      n(void 0);
  }, [
    e
  ]), t;
}
const F = /* @__PURE__ */ E((e, t) => {
  const { children: n, ...o } = e, c = B.toArray(n), r = c.find(ze);
  if (r) {
    const a = r.props.children, i = c.map((l) => l === r ? B.count(a) > 1 ? B.only(null) : /* @__PURE__ */ H(a) ? a.props.children : null : l);
    return /* @__PURE__ */ h(G, P({}, o, {
      ref: t
    }), /* @__PURE__ */ H(a) ? /* @__PURE__ */ ie(a, void 0, i) : null);
  }
  return /* @__PURE__ */ h(G, P({}, o, {
    ref: t
  }), n);
});
F.displayName = "Slot";
const G = /* @__PURE__ */ E((e, t) => {
  const { children: n, ...o } = e;
  return /* @__PURE__ */ H(n) ? /* @__PURE__ */ ie(n, {
    ...Oe(o, n.props),
    ref: t ? se(t, n.ref) : n.ref
  }) : B.count(n) > 1 ? B.only(null) : null;
});
G.displayName = "SlotClone";
const Be = ({ children: e }) => /* @__PURE__ */ h(Ee, null, e);
function ze(e) {
  return /* @__PURE__ */ H(e) && e.type === Be;
}
function Oe(e, t) {
  const n = {
    ...t
  };
  for (const o in t) {
    const c = e[o], r = t[o];
    /^on[A-Z]/.test(o) ? c && r ? n[o] = (...i) => {
      r(...i), c(...i);
    } : c && (n[o] = c) : o === "style" ? n[o] = {
      ...c,
      ...r
    } : o === "className" && (n[o] = [
      c,
      r
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const Le = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], U = Le.reduce((e, t) => {
  const n = /* @__PURE__ */ E((o, c) => {
    const { asChild: r, ...a } = o, i = r ? F : t;
    return z(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ h(i, P({}, a, {
      ref: c
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function He(e) {
  const t = e + "CollectionProvider", [n, o] = le(t), [c, r] = n(t, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), a = (m) => {
    const { scope: f, children: p } = m, $ = D.useRef(null), b = D.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ D.createElement(c, {
      scope: f,
      itemMap: b,
      collectionRef: $
    }, p);
  }, i = e + "CollectionSlot", l = /* @__PURE__ */ D.forwardRef((m, f) => {
    const { scope: p, children: $ } = m, b = r(i, p), w = M(f, b.collectionRef);
    return /* @__PURE__ */ D.createElement(F, {
      ref: w
    }, $);
  }), d = e + "CollectionItemSlot", v = "data-radix-collection-item", s = /* @__PURE__ */ D.forwardRef((m, f) => {
    const { scope: p, children: $, ...b } = m, w = D.useRef(null), S = M(f, w), x = r(d, p);
    return D.useEffect(() => (x.itemMap.set(w, {
      ref: w,
      ...b
    }), () => void x.itemMap.delete(w))), /* @__PURE__ */ D.createElement(F, {
      [v]: "",
      ref: S
    }, $);
  });
  function u(m) {
    const f = r(e + "CollectionConsumer", m);
    return D.useCallback(() => {
      const $ = f.collectionRef.current;
      if (!$) return [];
      const b = Array.from($.querySelectorAll(`[${v}]`));
      return Array.from(f.itemMap.values()).sort(
        (x, R) => b.indexOf(x.ref.current) - b.indexOf(R.ref.current)
      );
    }, [
      f.collectionRef,
      f.itemMap
    ]);
  }
  return [
    {
      Provider: a,
      Slot: l,
      ItemSlot: s
    },
    u,
    o
  ];
}
const ue = [
  "PageUp",
  "PageDown"
], fe = [
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight"
], $e = {
  "from-left": [
    "Home",
    "PageDown",
    "ArrowDown",
    "ArrowLeft"
  ],
  "from-right": [
    "Home",
    "PageDown",
    "ArrowDown",
    "ArrowRight"
  ],
  "from-bottom": [
    "Home",
    "PageDown",
    "ArrowDown",
    "ArrowLeft"
  ],
  "from-top": [
    "Home",
    "PageDown",
    "ArrowUp",
    "ArrowLeft"
  ]
}, O = "Slider", [q, Fe, Ue] = He(O), [pe, ht] = le(O, [
  Ue
]), [Ye, Y] = pe(O), je = /* @__PURE__ */ E((e, t) => {
  const { name: n, min: o = 0, max: c = 100, step: r = 1, orientation: a = "horizontal", disabled: i = !1, minStepsBetweenThumbs: l = 0, defaultValue: d = [
    o
  ], value: v, onValueChange: s = () => {
  }, onValueCommit: u = () => {
  }, inverted: m = !1, ...f } = e, [p, $] = N(null), b = M(
    t,
    (g) => $(g)
  ), w = _(/* @__PURE__ */ new Set()), S = _(0), x = a === "horizontal", R = p ? !!p.closest("form") : !0, J = x ? We : Xe, [y = [], ge] = Ae({
    prop: v,
    defaultProp: d,
    onChange: (g) => {
      var C;
      (C = [
        ...w.current
      ][S.current]) === null || C === void 0 || C.focus(), s(g);
    }
  }), Q = _(y);
  function xe(g) {
    const C = ot(y, g);
    V(g, C);
  }
  function we(g) {
    V(g, S.current);
  }
  function ye() {
    const g = Q.current[S.current];
    y[S.current] !== g && u(y);
  }
  function V(g, C, { commit: L } = {
    commit: !1
  }) {
    const ee = at(r), j = st(Math.round((g - o) / r) * r + o, ee), k = ae(j, [
      o,
      c
    ]);
    ge((I = []) => {
      const A = tt(I, k, C);
      if (it(A, l * r)) {
        S.current = A.indexOf(k);
        const te = String(A) !== String(I);
        return te && L && u(A), te ? A : I;
      } else return I;
    });
  }
  return /* @__PURE__ */ h(Ye, {
    scope: e.__scopeSlider,
    disabled: i,
    min: o,
    max: c,
    valueIndexToChangeRef: S,
    thumbs: w.current,
    values: y,
    orientation: a
  }, /* @__PURE__ */ h(q.Provider, {
    scope: e.__scopeSlider
  }, /* @__PURE__ */ h(q.Slot, {
    scope: e.__scopeSlider
  }, /* @__PURE__ */ h(J, P({
    "aria-disabled": i,
    "data-disabled": i ? "" : void 0
  }, f, {
    ref: b,
    onPointerDown: K(f.onPointerDown, () => {
      i || (Q.current = y);
    }),
    min: o,
    max: c,
    inverted: m,
    onSlideStart: i ? void 0 : xe,
    onSlideMove: i ? void 0 : we,
    onSlideEnd: i ? void 0 : ye,
    onHomeKeyDown: () => !i && V(o, 0, {
      commit: !0
    }),
    onEndKeyDown: () => !i && V(c, y.length - 1, {
      commit: !0
    }),
    onStepKeyDown: ({ event: g, direction: C }) => {
      if (!i) {
        const j = ue.includes(g.key) || g.shiftKey && fe.includes(g.key) ? 10 : 1, k = S.current, I = y[k], A = r * j * C;
        V(I + A, k, {
          commit: !0
        });
      }
    }
  })))), R && y.map(
    (g, C) => /* @__PURE__ */ h(et, {
      key: C,
      name: n ? n + (y.length > 1 ? "[]" : "") : void 0,
      value: g
    })
  ));
}), [me, Se] = pe(O, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), We = /* @__PURE__ */ E((e, t) => {
  const { min: n, max: o, dir: c, inverted: r, onSlideStart: a, onSlideMove: i, onSlideEnd: l, onStepKeyDown: d, ...v } = e, [s, u] = N(null), m = M(
    t,
    (S) => u(S)
  ), f = _(), p = Te(c), $ = p === "ltr", b = $ && !r || !$ && r;
  function w(S) {
    const x = f.current || s.getBoundingClientRect(), R = [
      0,
      x.width
    ], y = Z(R, b ? [
      n,
      o
    ] : [
      o,
      n
    ]);
    return f.current = x, y(S - x.left);
  }
  return /* @__PURE__ */ h(me, {
    scope: e.__scopeSlider,
    startEdge: b ? "left" : "right",
    endEdge: b ? "right" : "left",
    direction: b ? 1 : -1,
    size: "width"
  }, /* @__PURE__ */ h(ve, P({
    dir: p,
    "data-orientation": "horizontal"
  }, v, {
    ref: m,
    style: {
      ...v.style,
      "--radix-slider-thumb-transform": "translateX(-50%)"
    },
    onSlideStart: (S) => {
      const x = w(S.clientX);
      a == null || a(x);
    },
    onSlideMove: (S) => {
      const x = w(S.clientX);
      i == null || i(x);
    },
    onSlideEnd: () => {
      f.current = void 0, l == null || l();
    },
    onStepKeyDown: (S) => {
      const R = $e[b ? "from-left" : "from-right"].includes(S.key);
      d == null || d({
        event: S,
        direction: R ? -1 : 1
      });
    }
  })));
}), Xe = /* @__PURE__ */ E((e, t) => {
  const { min: n, max: o, inverted: c, onSlideStart: r, onSlideMove: a, onSlideEnd: i, onStepKeyDown: l, ...d } = e, v = _(null), s = M(t, v), u = _(), m = !c;
  function f(p) {
    const $ = u.current || v.current.getBoundingClientRect(), b = [
      0,
      $.height
    ], S = Z(b, m ? [
      o,
      n
    ] : [
      n,
      o
    ]);
    return u.current = $, S(p - $.top);
  }
  return /* @__PURE__ */ h(me, {
    scope: e.__scopeSlider,
    startEdge: m ? "bottom" : "top",
    endEdge: m ? "top" : "bottom",
    size: "height",
    direction: m ? 1 : -1
  }, /* @__PURE__ */ h(ve, P({
    "data-orientation": "vertical"
  }, d, {
    ref: s,
    style: {
      ...d.style,
      "--radix-slider-thumb-transform": "translateY(50%)"
    },
    onSlideStart: (p) => {
      const $ = f(p.clientY);
      r == null || r($);
    },
    onSlideMove: (p) => {
      const $ = f(p.clientY);
      a == null || a($);
    },
    onSlideEnd: () => {
      u.current = void 0, i == null || i();
    },
    onStepKeyDown: (p) => {
      const b = $e[m ? "from-bottom" : "from-top"].includes(p.key);
      l == null || l({
        event: p,
        direction: b ? -1 : 1
      });
    }
  })));
}), ve = /* @__PURE__ */ E((e, t) => {
  const { __scopeSlider: n, onSlideStart: o, onSlideMove: c, onSlideEnd: r, onHomeKeyDown: a, onEndKeyDown: i, onStepKeyDown: l, ...d } = e, v = Y(O, n);
  return /* @__PURE__ */ h(U.span, P({}, d, {
    ref: t,
    onKeyDown: K(e.onKeyDown, (s) => {
      s.key === "Home" ? (a(s), s.preventDefault()) : s.key === "End" ? (i(s), s.preventDefault()) : ue.concat(fe).includes(s.key) && (l(s), s.preventDefault());
    }),
    onPointerDown: K(e.onPointerDown, (s) => {
      const u = s.target;
      u.setPointerCapture(s.pointerId), s.preventDefault(), v.thumbs.has(u) ? u.focus() : o(s);
    }),
    onPointerMove: K(e.onPointerMove, (s) => {
      s.target.hasPointerCapture(s.pointerId) && c(s);
    }),
    onPointerUp: K(e.onPointerUp, (s) => {
      const u = s.target;
      u.hasPointerCapture(s.pointerId) && (u.releasePointerCapture(s.pointerId), r(s));
    })
  }));
}), Ge = "SliderTrack", qe = /* @__PURE__ */ E((e, t) => {
  const { __scopeSlider: n, ...o } = e, c = Y(Ge, n);
  return /* @__PURE__ */ h(U.span, P({
    "data-disabled": c.disabled ? "" : void 0,
    "data-orientation": c.orientation
  }, o, {
    ref: t
  }));
}), ne = "SliderRange", Ze = /* @__PURE__ */ E((e, t) => {
  const { __scopeSlider: n, ...o } = e, c = Y(ne, n), r = Se(ne, n), a = _(null), i = M(t, a), l = c.values.length, d = c.values.map(
    (u) => he(u, c.min, c.max)
  ), v = l > 1 ? Math.min(...d) : 0, s = 100 - Math.max(...d);
  return /* @__PURE__ */ h(U.span, P({
    "data-orientation": c.orientation,
    "data-disabled": c.disabled ? "" : void 0
  }, o, {
    ref: i,
    style: {
      ...e.style,
      [r.startEdge]: v + "%",
      [r.endEdge]: s + "%"
    }
  }));
}), oe = "SliderThumb", Je = /* @__PURE__ */ E((e, t) => {
  const n = Fe(e.__scopeSlider), [o, c] = N(null), r = M(
    t,
    (i) => c(i)
  ), a = T(
    () => o ? n().findIndex(
      (i) => i.ref.current === o
    ) : -1,
    [
      n,
      o
    ]
  );
  return /* @__PURE__ */ h(Qe, P({}, e, {
    ref: r,
    index: a
  }));
}), Qe = /* @__PURE__ */ E((e, t) => {
  const { __scopeSlider: n, index: o, ...c } = e, r = Y(oe, n), a = Se(oe, n), [i, l] = N(null), d = M(
    t,
    ($) => l($)
  ), v = ke(i), s = r.values[o], u = s === void 0 ? 0 : he(s, r.min, r.max), m = nt(o, r.values.length), f = v == null ? void 0 : v[a.size], p = f ? rt(f, u, a.direction) : 0;
  return z(() => {
    if (i)
      return r.thumbs.add(i), () => {
        r.thumbs.delete(i);
      };
  }, [
    i,
    r.thumbs
  ]), /* @__PURE__ */ h("span", {
    style: {
      transform: "var(--radix-slider-thumb-transform)",
      position: "absolute",
      [a.startEdge]: `calc(${u}% + ${p}px)`
    }
  }, /* @__PURE__ */ h(q.ItemSlot, {
    scope: e.__scopeSlider
  }, /* @__PURE__ */ h(U.span, P({
    role: "slider",
    "aria-label": e["aria-label"] || m,
    "aria-valuemin": r.min,
    "aria-valuenow": s,
    "aria-valuemax": r.max,
    "aria-orientation": r.orientation,
    "data-orientation": r.orientation,
    "data-disabled": r.disabled ? "" : void 0,
    tabIndex: r.disabled ? void 0 : 0
  }, c, {
    ref: d,
    style: s === void 0 ? {
      display: "none"
    } : e.style,
    onFocus: K(e.onFocus, () => {
      r.valueIndexToChangeRef.current = o;
    })
  }))));
}), et = (e) => {
  const { value: t, ...n } = e, o = _(null), c = Ne(t);
  return z(() => {
    const r = o.current, a = window.HTMLInputElement.prototype, l = Object.getOwnPropertyDescriptor(a, "value").set;
    if (c !== t && l) {
      const d = new Event("input", {
        bubbles: !0
      });
      l.call(r, t), r.dispatchEvent(d);
    }
  }, [
    c,
    t
  ]), /* @__PURE__ */ h("input", P({
    style: {
      display: "none"
    }
  }, n, {
    ref: o,
    defaultValue: t
  }));
};
function tt(e = [], t, n) {
  const o = [
    ...e
  ];
  return o[n] = t, o.sort(
    (c, r) => c - r
  );
}
function he(e, t, n) {
  const r = 100 / (n - t) * (e - t);
  return ae(r, [
    0,
    100
  ]);
}
function nt(e, t) {
  return t > 2 ? `Value ${e + 1} of ${t}` : t === 2 ? [
    "Minimum",
    "Maximum"
  ][e] : void 0;
}
function ot(e, t) {
  if (e.length === 1) return 0;
  const n = e.map(
    (c) => Math.abs(c - t)
  ), o = Math.min(...n);
  return n.indexOf(o);
}
function rt(e, t, n) {
  const o = e / 2, r = Z([
    0,
    50
  ], [
    0,
    o
  ]);
  return (o - r(t) * n) * n;
}
function ct(e) {
  return e.slice(0, -1).map(
    (t, n) => e[n + 1] - t
  );
}
function it(e, t) {
  if (t > 0) {
    const n = ct(e);
    return Math.min(...n) >= t;
  }
  return !0;
}
function Z(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const o = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + o * (n - e[0]);
  };
}
function at(e) {
  return (String(e).split(".")[1] || "").length;
}
function st(e, t) {
  const n = Math.pow(10, t);
  return Math.round(e * n) / n;
}
const be = je, lt = qe, dt = Ze, ut = Je, ft = Pe.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ Ce(
  be,
  {
    ref: n,
    className: De("relative flex w-full touch-none select-none items-center", e),
    ...t,
    children: [
      /* @__PURE__ */ W(lt, { className: "relative h-2 w-full grow overflow-hidden rounded-full bg-secondary", children: /* @__PURE__ */ W(dt, { className: "absolute h-full bg-primary" }) }),
      /* @__PURE__ */ W(ut, { className: "block size-5 rounded-full border-2 border-primary bg-background ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50" })
    ]
  }
));
ft.displayName = be.displayName;
export {
  ft as Slider
};
//# sourceMappingURL=slider.js.map
